import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import CustomerDetail from './pages/customers/CustomerDetail';
import Deals from './pages/Deals';
import Tasks from './pages/Tasks';
import Users from './pages/Users';
import Layout from './components/Layout';
import FinanceDashboard from './pages/finance/FinanceDashboard';
import Invoices from './pages/finance/Invoices';
import InvoiceForm from './pages/finance/InvoiceForm';
import Expenses from './pages/finance/Expenses';
import ExpenseForm from './pages/finance/ExpenseForm';
import Approvals from './pages/finance/Approvals';
import Profitability from './pages/finance/Profitability';
import InvoiceDetail from './pages/finance/InvoiceDetail';
import Recurring from './pages/finance/Recurring';

function PrivateRoute({ children, adminOnly, financeOnly }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-12 h-12 bg-indigo-600 rounded-2xl flex items-center justify-center text-2xl">🦘</div>
        <div className="text-slate-400 text-sm">Yukleniyor...</div>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && user.role !== 'super_admin') return <Navigate to="/" />;
  if (financeOnly && !['super_admin', 'finance'].includes(user.role)) return <Navigate to="/" />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
          <Route path="/customers/:id" element={<PrivateRoute><CustomerDetail /></PrivateRoute>} />
          <Route path="/deals" element={<PrivateRoute><Deals /></PrivateRoute>} />
          <Route path="/tasks" element={<PrivateRoute><Tasks /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute adminOnly><Users /></PrivateRoute>} />
          <Route path="/finance" element={<PrivateRoute financeOnly><FinanceDashboard /></PrivateRoute>} />
          <Route path="/finance/invoices" element={<PrivateRoute financeOnly><Invoices /></PrivateRoute>} />
          <Route path="/finance/invoices/:id" element={<PrivateRoute financeOnly><InvoiceDetail /></PrivateRoute>} />
          <Route path="/finance/invoices/new" element={<PrivateRoute financeOnly><InvoiceForm /></PrivateRoute>} />
          <Route path="/finance/expenses" element={<PrivateRoute financeOnly><Expenses /></PrivateRoute>} />
          <Route path="/finance/expenses/new" element={<PrivateRoute financeOnly><ExpenseForm /></PrivateRoute>} />
          <Route path="/finance/approvals" element={<PrivateRoute adminOnly><Approvals /></PrivateRoute>} />
          <Route path="/finance/profitability" element={<PrivateRoute financeOnly><Profitability /></PrivateRoute>} />
          <Route path="/finance/recurring" element={<PrivateRoute financeOnly><Recurring /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
